import { createFileRoute } from '@tanstack/react-router';
import { SubmittedDetails } from '../../../layouts/SubmittedDetails/SubmittedDetails';

export const Route = createFileRoute('/$retailer/submitted-details/$requestId')(
  {
    component: SubmittedDetails,
  },
);
